// Per-provider rollout of the new Deal UI (#1780). The CloudFront function `deal-ui-switch`
// (docs/UI_SWITCH/) serves this app or the old one by the `ui` cookie; this app sends providers
// without the `ui.newVersion` entitlement back to the old one. `auto=1` makes CloudFront keep that
// choice for one day only, so a provider enabled later reaches the new UI within a day.
export const NEW_VERSION_FEATURE = 'ui.newVersion';
export const OLD_UI_URL = '/?ui=old&auto=1';

const PROVIDER_ROUTE = /^\/providers\/(\d+)(\/|$)/;

export const routeProviderId = pathname => {
  const match = PROVIDER_ROUTE.exec(pathname || '');
  return match ? Number(match[1]) : null;
};

const parse = value => {
  try {
    return typeof value === 'string' ? JSON.parse(value) : value || {};
  } catch {
    return {};
  }
};

// Only an answer for the provider in the URL decides; a failed or mismatched answer
// (e.g. the token not yet switched to that provider) never redirects.
export const shouldSendToOldUi = ({ enabled, isAdmin, providerId, entitlements }) => {
  if (!enabled || isAdmin || !providerId || !entitlements) return false;
  if (Number(entitlements.providerId) !== providerId) return false;
  return !parse(entitlements.booleans)[NEW_VERSION_FEATURE];
};
